import { useMutation } from "react-query";
import api from "../../client";
import { Interaction, UpdateInteractionPayload } from "../../types/interaction";

const patchData = async (
  id: string | undefined,
  payload: UpdateInteractionPayload,
): Promise<Interaction> => {
  const { data } = await api.patch(`/interactions/${id}`, payload);

  return data;
};

export const useUpdateInteraction = (id: string | undefined) => {
  return useMutation((payload: UpdateInteractionPayload) => {
    return patchData(id, payload);
  });
};
